import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';

import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { PbxService } from 'src/app/domains/companies/services/pbx.service';
import { Queue, QueueMigrateResponse, QueueMigrateResult, QUEUE_MIGRATION_STAGE } from 'src/app/domains/queues/models';
import { QueuesService } from 'src/app/domains/queues/services';
import { Pbx } from 'src/app/domains/companies/models/pbx.model';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-queue-module-popup',
  templateUrl: './queue-module-popup.component.html',
  styleUrls: ['./queue-module-popup.component.scss']
})
export class QueueModulePopupComponent implements OnInit {
  @Input() pbx: Pbx;
  @Input() queues: Queue[];
  @Input() queueModules: string[];
  @Output() moduleChanged: EventEmitter<string> = new EventEmitter<string>();
  queueModule: UntypedFormControl;
  loading: boolean = false;

  constructor(
    private modal: NgbActiveModal,
    private queueService: QueuesService,
    private notification: NotificationService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.queueModule = new UntypedFormControl(
      this.queues.length === 1 ? this.queues[0].module : this.queueModules[0],
      [Validators.required]
    );
  }

  selectQueueModule(m: string) {
    this.queueModule.setValue(m);
  }

  saveModule() {
    this.loading = true;
    this.queueService.migrateQueues(
      this.pbx.id,
      this.queues.map(q => q.id),
      this.queueModule.value)
      .subscribe(
        (response: QueueMigrateResponse) => {
          response.forEach(
            (r: QueueMigrateResult) =>{
              if (!r.success) {
                const stage: string =  r.failed_stages.map(s => s.stage).toString();
                const error: string = r.failed_stages.map(s => s.error_message).toString();
                this.notification.error(
                  this.translate.instant(
                    'company.queues.module-popup.migrate-error',
                    { name: r.resource.name, stage, error }
                  )
                );
              }
            }
          );
          this.loading = false;
          this.moduleChanged.emit(this.queueModule.value);
          this.close();
        }, () => {
          this.loading = false;
          this.close();
        });
  }

  public get canSubmit() {
    return this.queues.length === 1
      ? this.queueModule.value !== this.queues[0].module
      : true
  }

  public close() {
    this.modal.close()
  }

}
